import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c71177a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "withholding-finished" }
const _hoisted_2 = { class: "px-3" }
const _hoisted_3 = { class: "summary-area text-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-left text-size-14 text-weight-500 mt-4" }, [
  /*#__PURE__*/_createTextVNode("\n            お疲れ様でした！"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("\n            評価はお互いの評価完了後に反映されます"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "small text-weight-500" }, "\n            今回のお仕事はいかがでしたか？またお仕事したい場合は、お気に入り登録してお仕事を探しましょう！\n          ", -1))
const _hoisted_6 = { class: "text-size-14 text-weight-500 mt-4" }
const _hoisted_7 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Balloon = _resolveComponent("Balloon")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppButtonOutline = _resolveComponent("AppButtonOutline")!
  const _component_BlockBack = _resolveComponent("BlockBack")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      default: _withCtx(() => [
        _createTextVNode("\n      評価完了\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Balloon),
          _createTextVNode(),
          _hoisted_4
        ]),
        _createTextVNode(),
        (_ctx.isNotYetFavorite && _ctx.office)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_5,
              _createTextVNode(),
              _createVNode(_component_AppButton, {
                block: true,
                class: "mt-3",
                onClick: _ctx.onClickFavorite
              }, {
                default: _withCtx(() => [
                  _createTextVNode("お気に入り登録して仕事を見る\n          ")
                ], undefined, true),
                _: 1
              }, 8, ["onClick"])
            ], 64))
          : _createCommentVNode("", true),
        _createTextVNode(),
        _createVNode(_component_AppButton, {
          to: { name: 'Salary' },
          block: true,
          class: "mt-3"
        }, {
          default: _withCtx(() => [
            _createTextVNode("給与を確認\n        ")
          ], undefined, true),
          _: 1
        }),
        _createTextVNode(),
        _createVNode(_component_AppButtonOutline, {
          to: { name: 'ApplicationsList' },
          block: true,
          class: "d-block mt-3"
        }, {
          default: _withCtx(() => [
            _createTextVNode("\n          仕事管理に戻る\n        ")
          ], undefined, true),
          _: 1
        }),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_6, [
          _createTextVNode("\n          直接事業所に伝えづらいことやカイテクへのご意見は"),
          _createElementVNode("a", {
            href: _ctx.externalLink.anonymousFeedbackForm,
            class: "external-link"
          }, "こちら", 8, _hoisted_7)
        ])
      ])
    ]),
    _createTextVNode(),
    _createVNode(_component_BlockBack)
  ]))
}